import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-center flex-wrap",
  style: {"gap":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100" })
], -1)

import { ref, watch, withDefaults, onMounted } from 'vue';
import { MoleculeModal, MoleculeListActions } from '@/components/molecules';
import { Application, ApplicationVersion, Company, Group, Licence, LicenceGroup, User } from '@/core/model';
import { create, update } from '@/core/service/UserService';

import { getAll as groupAll } from '@/core/service/GroupService';
import { validateCPF, validateEmail } from '@/core/service/ValidateService';
import { Preloader } from '@/store';
import Swal from 'sweetalert2';
import {
  AtomInput,
  GroupIcon,
  AtomButton,
  SearchIcon,
  AtomCheckBox,
  AtomAccordion,
  AtomSelect,
} from '@/components/atoms';
import { computed } from 'vue';
import { Authentication } from '@/store';
import { increment } from '@/core/service/LicenceService';

interface IProps {
  showModal: boolean;
  licence?: Licence;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalExport',
  props: {
    showModal: { type: Boolean, default: false },
    licence: null
  },
  emits: ['onHandleClose'],
  setup(__props: any, { emit }) {

const props = __props as { showModal: boolean, licence?: Licence };



const uses_increment = ref<number>(0);

const disabledButton = computed(() => {
  return !uses_increment.value;
});

function handleIncremente() {
  increment({ id: props.licence?.id, uses_increment: uses_increment.value }).then(() => {
    Swal.fire({
      icon: 'success',
      title: 'Sucesso',
      text: 'Adição de licença realizado com sucesso',
    }).then(() => {
      emit('onHandleClose', false);
    });
  });
}

function clear() {
  uses_increment.value = 0;
  emit('onHandleClose', false);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    width: "649px",
    onHandleConfirm: handleIncremente,
    onHandleCancel: clear,
    icon: "ArchiveBookIcon",
    iconColor: "#5528B5",
    title: "Adicionar mais licenças",
    show: __props.showModal,
    "btn-close-text": "Cancelar",
    "btn-confirm-text": "Adicionar",
    btnConfitmDisabled: _unref(disabledButton)
  }, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["show", "btnConfitmDisabled"]))
}
}

})